import { Button, Card, CardContent, CardHeader, CardTitle } from "@repo/ui";
import { Link } from "react-router-dom";

export function Home() {
  return (
    <div>
      <section className="relative overflow-hidden">
        <div className="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-10 items-center">
          <div>
            <h1
              className="text-5xl md:text-6xl font-bold leading-tight mb-4"
              style={{ fontFamily: "var(--font-display)" }}
            >
              Sricha Bloom
            </h1>
            <p className="text-lg text-muted-foreground mb-6">
              A colorful, retro flower shop celebrating the poetry of petals. We craft bouquets with
              love and passion—right here in Velaa Sindhorn Village, Bangkok.
            </p>
            <div className="flex gap-3">
              <Button asChild>
                <Link to="/order">Order Bouquets</Link>
              </Button>
              <Button variant="secondary" asChild>
                <Link to="/booking">Book a Class</Link>
              </Button>
            </div>
          </div>
          <div className="relative">
            <div className="absolute -top-6 -left-6 size-28 rounded-full bg-accent/20 blur-2xl" />
            <div className="absolute -bottom-8 -right-10 size-32 rounded-full bg-secondary/30 blur-2xl" />
            <img
              src="https://images.pexels.com/photos/931166/pexels-photo-931166.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Colorful bouquet"
              className="relative z-10 w-full rounded-[1.25rem] border border-border"
            />
          </div>
        </div>
      </section>

      <section className="bg-muted/40 border-y border-border">
        <div className="max-w-6xl mx-auto px-6 py-14 grid md:grid-cols-3 gap-6">
          <Card>
            <CardHeader>
              <CardTitle>Love in Every Stem</CardTitle>
            </CardHeader>
            <CardContent className="text-sm text-muted-foreground">
              Every bouquet is arranged by hand with care, rhythm, and a little bit of old-school
              flair.
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <CardTitle>Bright & Retro</CardTitle>
            </CardHeader>
            <CardContent className="text-sm text-muted-foreground">
              Bold yellows, reds, and blues lead our palette—nostalgic colors for timeless feelings.
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <CardTitle>Bangkok Roots</CardTitle>
            </CardHeader>
            <CardContent className="text-sm text-muted-foreground">
              Nestled in Velaa Sindhorn Village, we’re your neighborhood bloom studio from dawn to
              late.
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
}
